import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FiLock, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { toast } from 'react-toastify';
import authService from '../../services/auth.service';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await authService.resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="section-padding d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
        <div className="text-center" style={{ maxWidth: '420px' }}>
          <FiCheckCircle size={56} className="text-success mb-3" />
          <h3>Password Reset!</h3>
          <p className="text-muted">Your password has been updated successfully. Redirecting to login...</p>
          <Link to="/login" className="btn btn-ebw-primary mt-3">Go to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="section-padding d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
      <div className="auth-page" style={{ maxWidth: '420px', width: '100%' }}>
        <div className="dashboard-card">
          <h3 className="mb-2">Set New Password</h3>
          <p className="text-muted mb-4">Enter your new password below.</p>

          {error && (
            <div className="alert alert-danger d-flex align-items-center gap-2 py-2">
              <FiAlertCircle /> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <div style={{ position: 'relative' }}>
                <div className="input-group">
                  <span className="input-group-text"><FiLock /></span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    style={{ paddingRight: '44px' }}
                    placeholder="At least 6 characters"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={6}
                  />
                </div>
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#9CA3AF', fontSize: '18px', zIndex: 5 }}>
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">Confirm Password</label>
              <div style={{ position: 'relative' }}>
                <div className="input-group">
                  <span className="input-group-text"><FiLock /></span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    style={{ paddingRight: '44px' }}
                    placeholder="Confirm your password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#9CA3AF', fontSize: '18px', zIndex: 5 }}>
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-ebw-primary w-100 btn-lg" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
